// export const gateKey = '';
export const gateKey = '';
export const recaptchaKey = '6Ld9r7cZAAAAABw5wijiLD5PhlWqLivIN9NqFKi_';
export const apiUrl = 'https://api-jornadasuldermato.encontrodigital.com.br';
export const apiSocket = 'https://socketv3.encontrodigital.com.br/';
//export const apiSocket = 'http://localhost:8001';
//export const apiUrl = 'http://localhost:8000';
export const urlWebsite = 'https://jornadasuldermato.encontrodigital.com.br';

export const home = 'SignIn';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = '28ª Jornada Sul Brasileira de Dermatologia';
export const logo = '/assets/evento/logo.png';
export const background = '/assets/evento/fundo.png';
export const authTitle = 'suldermato';
export const hash = 'd9adb23b-41af-421b-97c7-7a7e2db89a6c';
export const supportNumber = '555198535344';
export const social = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  website: '',
  linkedin: '',
  youtube: '',
  twitter: '',
};

export const dadosOrganizacao = ``;

export const defaultTheme = {
  lightColor: '#fff',
  darkColor: '#fff',
  defaultBackground: '#36A99A',
  defaultColor: '#fff',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: 'none',
    backgroundSticky: '#36A99A',
    backgroundMobile: '#36A99A',
    mobileColor: '#fff',
    color: '#fff',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
